import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class DiaryService {

    private isNotInBranch = new BehaviorSubject(null);

    sendIsNotInBranchValue(value: boolean) {
        this.isNotInBranch.next(value);
    }

    getIsNotInBranchValue() {
        return this.isNotInBranch.asObservable();
    }
}
